(function () {
  'use strict';

  function isYoutube(url) {
    return /^https?:\/\/(www\.)?youtube\.com|^https?:\/\/youtu\.be/.test(url || '');
  }

  function isVimeo(url) {
    return /^https?:\/\/(player\.)?vimeo\.com/.test(url || '');
  }

  function setAutoplay(iframe) {
    if (!iframe || !iframe.src) return;
    if (iframe.src.indexOf('autoplay=0') !== -1) {
      iframe.src = iframe.src.replace('autoplay=0', 'autoplay=1');
    } else if (iframe.src.indexOf('autoplay=1') === -1) {
      iframe.src += iframe.src.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1';
    }
  }

  function playMedia(videoEl) {
    if (!videoEl) return;
    if (videoEl.tagName === 'VIDEO') {
      var playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    } else if (videoEl.tagName === 'IFRAME' && isYoutube(videoEl.src)) {
      videoEl.contentWindow && videoEl.contentWindow.postMessage('{"event":"command","func":"playVideo","args":[]}', '*');
    } else if (videoEl.tagName === 'IFRAME' && isVimeo(videoEl.src)) {
      videoEl.contentWindow && videoEl.contentWindow.postMessage({ method: 'play', value: {} }, '*');
    }
  }

  function bindRoot(root) {
    if (!root || root.dataset.kikUgcVideosBound === 'true') return;
    root.dataset.kikUgcVideosBound = 'true';
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-video-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      event.stopPropagation();

      var container = trigger.closest('.xo-embed-responsive') || trigger.closest('.xo-video') || trigger.closest('xo-video-custom');
      if (!container) return;

      var deferred = container.querySelector('kik-deferred-media');
      if (deferred) {
        var template = deferred.querySelector('template');
        if (template) {
          deferred.after(template.content.cloneNode(true));
        }
        deferred.remove();
      }

      var poster = container.querySelector('.xo-video__poster');
      var button = container.querySelector('.xo-video__button');
      var videoEl = container.querySelector('video, iframe');

      if (poster) poster.style.display = 'none';
      if (button) button.style.display = 'none';
      if (videoEl) {
        videoEl.style.display = 'block';
        if (videoEl.tagName === 'IFRAME') setAutoplay(videoEl);
        playMedia(videoEl);
      }
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-kik-ugc-videos]');
    roots.forEach(bindRoot);
  }

  window.KikUgcVideos = {
    ready: true,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
